/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Period_YearInputs */



/**
* | output |
* | --- |
* | "year" |
*
* @param {Signup_Period_YearInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_period_year = /** @type {((inputs?: Signup_Period_YearInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Period_YearInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("year")
	if (locale === "de") return /** @type {LocalizedString} */ ("year")
	if (locale === "it") return /** @type {LocalizedString} */ ("year")
	if (locale === "ru") return /** @type {LocalizedString} */ ("year")
	if (locale === "es") return /** @type {LocalizedString} */ ("year")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("year")
	if (locale === "ja") return /** @type {LocalizedString} */ ("year")
	if (locale === "hi") return /** @type {LocalizedString} */ ("year")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("year")
	return /** @type {LocalizedString} */ ("year")
});